import { ThunkResult } from "@/models/common/core/ThunkResult";
import { Cart } from "@/models/scope/cart/Cart";
import { getUserIdFromCookie, getBasketData } from "@/utils/responsive/utils";
import {
    CART_DATA_UPDATE,
    CART_DATA_UPDATE_ERROR,
    LAST_ADDED_ITEM
} from "@/redux/reducers/responsive/actionsTypes";
import {
    CART_DATA_UPDATE_ERROR_TYPES,
    CART_DATA_UPDATE_TYPES,
    LAST_ADDED_ITEM_TYPES
} from "redux/reducers/responsive/cart/cartTypes";
import { checkOlapicBloc } from "@/animations/responsive/productSheetPage";
import { addToCart } from "@/services/cartServices";
import OctipasMerch from '@/vendors/OctipasMerch'
import { addToCartProductSuccessTracking, addToCartProductFailledTracking } from "@/animations/responsive/productPageTracking";
import { SOLD_BY_BUT, SOLD_BY_MKP } from "@/utils/constants";

interface Params {
    productId: string;
    quantity: number;
    offerId?: number;
    sellerName?: string;
    callback?: () => void;
    trackingData?: {};
    warrantyCode?: string;
}

export function addToCartAction(params: Params): ThunkResult<CART_DATA_UPDATE_TYPES | CART_DATA_UPDATE_ERROR_TYPES | LAST_ADDED_ITEM_TYPES> {
    const { productId, quantity, offerId, sellerName, trackingData } = params;
    // productSheetAnimations.showLoader()
    let url = "/WebUsers/" + getUserIdFromCookie() + "/Cart?View=compact";
    //todo recuperer comingFrom
    let addedFrom = (window.appData.comingFrom == 't2s') ? 't2s' : 'nav';
    let hasOlapicContent = checkOlapicBloc();
    let data = {
        action: "addProducts",
        items: offerId ? [{
            id: productId,
            qty: quantity,
            addedFrom: addedFrom,
            offerId: offerId,
            hasOlapicContent: hasOlapicContent
        }] : [{
            id: productId,
            qty: quantity,
            addedFrom: addedFrom,
            hasOlapicContent: hasOlapicContent
        }]
    };
    return function (dispatch) {
        addToCart(url, data)
            .then((response: Cart) => {
                let modalToShow = '';
                // productSheetAnimations.hideLoader();
                if (response.consolidationMessages && response.consolidationMessages[0]
                    && response.consolidationMessages[0].code === "prodcut_added_to_cart") {
                    addToCartProductSuccessTracking(trackingData, quantity)
                    OctipasMerch?.createOrReplaceBasket(getBasketData(response.items))
                    modalToShow = 'successModal'
                } else {
                    addToCartProductFailledTracking(trackingData)
                    modalToShow = 'subscriptionModal'
                }
                const lastAddedItem = response.items.find(item => ((item.ean13 == productId) && (item.soldBy ==  (offerId ? SOLD_BY_MKP : SOLD_BY_BUT)))) || {};
                dispatch({
                    type: CART_DATA_UPDATE,
                    payload: {
                        totalQuantity: response.totalQuantities,
                        shopId: response.shopId,
                        consolidationMessages: response.consolidationMessages,
                        productSellerName: sellerName,
                        showModal: modalToShow,
                        cart: response,
                    }
                });
                dispatch({
                    type: LAST_ADDED_ITEM,
                    payload: lastAddedItem
                });
                if (!!params.warrantyCode) {
                    selectExtendedWarranty(productId, params.warrantyCode, true);
                }
            }).catch((error) => {
                addToCartProductFailledTracking(trackingData)
                console.log(error);
                dispatch({
                    type: CART_DATA_UPDATE_ERROR,
                    payload: {
                        cartUpdateError: true,
                    }
                });
            }).finally(() => {
                params.callback && params.callback();
            });
    }

}
export const selectExtendedWarranty = (productId: string, parentProductId: string, isChecked: boolean) => {
    let url = "/WebUsers/" + getUserIdFromCookie() + "/Cart?View=cart";
    let data = {
        action: (!isChecked) ? "removeProductsWarranty" : "addProductsWarranty",
        items: [{ id: productId, service: { code: parentProductId } }]
    };
    return addToCart(url, data);
}
